{
  "id": "campaign-081",
  "name": "Misty Gate",
  "seed": "campaign:81",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L....",
    ".....__.....",
    ".i.i.__.i.i.",
    "....h__.....",
    ".....__.....",
    ".i.i.__.i.i.",
    "..,,.__.....",
    "...,.__.....",
    ".i.i.__.i.i.",
    "....,__....~",
    "...q,__..x.~",
    "....,__.q..~",
    ".....__..x..",
    "..x.........",
    "......#....S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 5,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 11,
      "y": 9
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 0
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 81,
  "biome": "cemetery",
  "par": {
    "reel": 6141,
    "push": 5190,
    "selfPropelled": 4440,
    "tractor": 4340,
    "zeroTurn": 3201,
    "fairway": 2598
  },
  "routeTries": {
    "par": {
      "reel": 15,
      "push": 17,
      "selfPropelled": 13,
      "tractor": 12,
      "zeroTurn": 14,
      "fairway": 22
    }
  }
}
